import AddCardIcon from '@mui/icons-material/AddCard';
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import moment from 'moment';
import { useState } from 'react';
import { useGetIdentity, useGetList, useNotify, useRecordContext } from 'react-admin';
import { buttonStyles } from 'src/services/theme';

export const LearnButtonList = (props: any) => {
  const record: any = useRecordContext(props);
  const [isShowInstruction, setIsShowInstruction] = useState<boolean>(false);
  const [isLearning, setIsLearning] = useState<boolean>(false);
  const notify = useNotify();
  const { identity } = useGetIdentity();

  const {
    data: readers,
    isLoading: isLoadingObject,
    error: errorGetObject,
  } = useGetList('object', {
    pagination: { page: 1, perPage: 2 },
    filter: { type: 'NfcCodeTouch', name: 'Bar' },
  });

  const learnNfc = async (reader_id: string) => {
    const mutation = `
      mutation learnNfc($key_id: Int!, $reader_id: String!) {
        learn_nfc(params: { key_id: $key_id, reader_id: $reader_id }) {
          success
          nfc_id
          error
        }
      }
    `;

    const token = identity?.token;
    if (!token) {
      notify('No token', { type: 'error' });
      return;
    }
    const baseApiUrl = process.env.REACT_APP_BASE_API_URL || '';
    const response = await axios({
      url: baseApiUrl,
      method: 'post',
      headers: { Authorization: `Bearer ${token}` },
      data: { query: mutation, variables: { key_id: Number(record.id), reader_id } },
    });

    const result = response.data?.data?.learn_nfc;
    if (!result?.success) {
      throw new Error(result?.error || 'NFC learn failed');
    }
    return result;
  };

  const handleLearn = async (reader_id: string) => {
    setIsLearning(true);
    setIsShowInstruction(true);
    try {
      const result = await learnNfc(reader_id);
      notify(`NFC learn success: ${result.nfc_id}`, { type: 'success' });
    } catch (err: any) {
      notify(err.message || 'NFC learn failed', { type: 'error' });
    } finally {
      setIsLearning(false);
      setIsShowInstruction(false);
    }
  };

  if (isLoadingObject || ['NOSHOW', 'CANCELED', 'CHECKEDOUT'].includes(record['status'])) {
    return <></>;
  }
  if (errorGetObject) {
    return <p>ERROR</p>;
  }
  return record ? (
    <>
      <Box>
        {readers
          ?.filter((r) => r.name == 'Bar')
          .flatMap((reader) => (
            <Button
              size="small"
              variant="contained"
              sx={buttonStyles.info}
              key={reader.id}
              disabled={isLearning}
              startIcon={<AddCardIcon />}
              onClick={() => {
                handleLearn(reader.id);
              }}
            >
              {record.nfc_ids?.length ?? 0}
            </Button>
          ))}

        <Dialog open={isShowInstruction}>
          <DialogTitle>Learn NFC Tag</DialogTitle>
          <DialogContent sx={{ minWidth: 300 }}>
            <img
              src="learnNFC.png"
              alt="learnNFC"
              width="100%"
              height="100%"
              style={{ objectFit: 'contain', marginBottom: '10px' }}
            />
            <DialogContentText>{record.full_name}</DialogContentText>
            <DialogContentText>{`Room ${record.number}`}</DialogContentText>
            <DialogContentText>{`Arrival ${moment(record.arrival_time).format(
              'DD.MM.YYYY, HH:mm',
            )}`}</DialogContentText>
            <DialogContentText style={{ marginBottom: 35 }}>
              Hold the NFC tag at the location shown on your NFC reader...
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  ) : null;
};

LearnButtonList.defaultProps = { label: 'Key Card' };
